import React from 'react';
import { number, string } from 'prop-types';

const ChevronLeft = ({ width, height, viewBox }) => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={width} height={height} viewBox={viewBox}>
    <path fill="#6E0AD6" d="M15.53 6.53a.75.75 0 0 0-1.06-1.06l-6 6a.75.75 0 0 0 0 1.06l6 6a.75.75 0 0 0 1.06-1.06L10.06 12l5.47-5.47z" />
  </svg>
);

export default ChevronLeft;

ChevronLeft.propTypes = {
  width: number,
  height: number,
  viewBox: string,
};

ChevronLeft.defaultProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
};
